var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vfl-has-label"},[_c('label',{staticClass:"vfl-label",class:_vm.classObject,attrs:{"for":_vm.inputId}},[_vm._v(" "+_vm._s(_vm.floatLabel)+" ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }